
export default class NewsViewModel {
    constructor(data) {
        this.id = data.id;
        this.categoryName = data.newsCategoryName;
        this.createdAt = data.createdAt;
        this.title = data.title;
        this.body = data.body
        this.link = new LinkViewModel(data.link);
        this.priorityLevel = data.priorityLevel;
    }
}
class LinkViewModel {
    constructor(data) {
        this.label = data.label;
        this.url = data.url;
    }
}